import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import Loader from '@/modules/base/components/loader/loader'
import { toast } from '@/modules/base/components/toast/toastConfig'
import request from '@/modules/base/util/request'
import config from '../../../config'
import { user } from 'ampersand-app'

const MagicLogin = ({ token }) => {
  const navigate = useNavigate()

  useEffect(() => {
    request(`${config.resourceHost}user/magic-login/${token}`, { method: 'GET' })
      .then(async(response) => {
        await user.login(response.body, { noRedirect: true })
        navigate('/dashboard')
      })
      .catch(() => {
        toast.showToast({ message: 'Magic Link ungültig oder abgelaufen', type: 'error' })
        navigate('/login')
      })
  }, [navigate, token])

  return <Loader />
}

export default MagicLogin
